import "../styles/Hero.css";

function Hero() {
  return (
    <section className="hero">
      <h2>Discover Delicious Recipes</h2>
      <p>Authentic flavors. Handpicked dishes.</p>
    </section>
  );
}

export default Hero;